import React from 'react';
import { Apps } from '@material-ui/icons';
import { AppsIcons } from './AppsIcons';
export var getAppIconByName = function (name) {
    var iconName = React.createElement(Apps, null);
    if (!name)
        return iconName;
    var icon = AppsIcons.find(function (app) { return app.name.toLowerCase().trim() === String(name).toLowerCase().trim(); });
    if (icon)
        iconName = icon.icon;
    return iconName;
};
//# sourceMappingURL=getAppIconByName.js.map